module.exports = __webpack_public_path__ + "/images/cover-multi-men-share.2631d13.png";